/**
 * @generated SignedSource<<01e4fde1b9ecf7c6ccd3ee8c32a6d5ee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DetailedContactList_customerAccount$data = {
  readonly contacts: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: string;
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"DetailedContactListItem_contact">;
      } | null | undefined;
      readonly roles: ReadonlyArray<{
        readonly label: {
          readonly en: string | null | undefined;
        };
        readonly roleIdentifier: string;
      }> | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"DetailedContactListItem_customerAccount">;
  readonly " $fragmentType": "DetailedContactList_customerAccount";
};
export type DetailedContactList_customerAccount$key = {
  readonly " $data"?: DetailedContactList_customerAccount$data;
  readonly " $fragmentSpreads": FragmentRefs<"DetailedContactList_customerAccount">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DetailedContactList_customerAccount",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CustomerAccountContactConnection",
      "kind": "LinkedField",
      "name": "contacts",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CustomerAccountContactEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "DetailedContactListItem_contact"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CustomerAccountContactRole",
              "kind": "LinkedField",
              "name": "roles",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "roleIdentifier",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Label",
                  "kind": "LinkedField",
                  "name": "label",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "en",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DetailedContactListItem_customerAccount"
    }
  ],
  "type": "CustomerAccount",
  "abstractKey": null
};

(node as any).hash = "915c5a0c0379bd10f07449cf90a325be";

export default node;
